export default __webpack_public_path__ + "static/new7-02-4bae2ad2ac879f52ecfdbd84083e7b93.jpg";